const vcfRouterPaths = {
  root: '/vcf',
  details: '/vcf/:namespace/:groupId',
  overview: '/vcf/:namespace/:groupId/overview',
  sharing: '/vcf/:namespace/:groupId/sharing',
  settings: '/vcf/:namespace/:groupId/settings',
  contents: '/vcf/:namespace/:groupId/contents',
  metadata: '/vcf/:namespace/:groupId/metadata',
  activity: '/vcf/:namespace/:groupId/activity',
};

export default vcfRouterPaths;
